import React, { useEffect } from 'react';

import _ from 'lodash';

import {globalIsSticky} from '../../store/local-storage';
import {StyledStickyContainer, StyledStickyContentWrapper} from './styles';

interface StickyScrollContainerProps {
  disableMobile?: boolean;
  children: React.ReactNode;
}
const StickyScrollContainer = ({
  disableMobile = false,
  children,
}: StickyScrollContainerProps) => {
  const inputRef = React.useRef<HTMLDivElement | null>(null);
  const [isSticky, setIsSticky] = React.useState(false);
  const [ticking, setIsTicking] = React.useState(false);

  const onHandleScroll = () => {
    if (inputRef) {
      const containerBounding = inputRef.current?.getBoundingClientRect();
      if (containerBounding) {
        const isCurrentSticky = containerBounding.top < 0;
        if (isCurrentSticky && !isSticky) {
          globalIsSticky(true);
          setIsSticky(true);
        }
        if (!isCurrentSticky && isSticky) {
          globalIsSticky(false);
          setIsSticky(false);
        }
      }
    }
  };

  /** Prevent multiples scrolling calls */
  const onHandleScrollTicking = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        onHandleScroll();
        setIsTicking(false);
      });
      setIsTicking(true);
    }
  };

  useEffect(() => {
    if (window) {
      window.addEventListener('scroll', onHandleScrollTicking);
    }
    return () => {
      if (window) {
        window.removeEventListener('scroll', onHandleScrollTicking);
      }
    };
  }, [isSticky, setIsSticky, ticking, setIsTicking]);

  return (
    <div
      className="sticky-wrapper"
      ref={inputRef}
      style={{position: 'relative', zIndex: 1}}
    >
      <StyledStickyContainer
        className={`sticky-container ${isSticky ? 'sticky' : 'non-sticky'}`}
        disableMobile={disableMobile}
      >
        <StyledStickyContentWrapper>{children}</StyledStickyContentWrapper>
      </StyledStickyContainer>
    </div>
  );
};

export default StickyScrollContainer;
